//Call_[npm_run_updateIndexes]_to_update_this_file.

// @create-index

import _getDarkModePreference from './getDarkModePreference';
export const getDarkModePreference = _getDarkModePreference;
export default {getDarkModePreference};

